import PIXI from 'pixi.js/src';
import config from './../config/config';
import data from './../data/data';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import renderHelper from './../helpers/render';
import router from './../router/router';
import frameAnimationHelper from './../helpers/frame-animation';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const instructionsView = {
  swipeContainerWidth: 162,
  swipeContainerHeight: 274,
  tiltContainerWidth: 186,
  tiltContainerHeight: 274,
  viewingSectionInt: 0,
  advanceTimeout: 0,


  /**
   * Sets up the view
   * @param {Object} params - The route params
   * @returns {undefined} undefined
   */
  init(params) {
    const _this = this;
    const htmlEl = document.getElementsByTagName('HTML')[0];

    this.supportsDeviceMotion =
      htmlEl.className.indexOf('no-devicemotion') === -1;
    this.params = params;

    this.backgroundSquare = new PIXI.Graphics();
    this.backgroundSquare.beginFill(config.thunderOrange);
    this.backgroundSquare.drawRect(
      0,
      0,
      window.innerWidth,
      window.innerHeight);
    renderHelper.stage.addChild(this.backgroundSquare);

    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    this.resizeListener = this.onResize.bind(this);
    this.advanceListener = this.advanceInstructions.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);

    setTimeout(() => {
      document.addEventListener('touchend', _this.advanceListener);
    }, 100);

    this.showSwipeInstructions();

    AppDispatcher.handleViewAction({
      actionType: AppConstants.INSTRUCTIONS_VIEWED,
    });
  },


  /**
   * Shows the swipe instructions
   * @returns {undefined} undefined
   */
  showSwipeInstructions() {
    const _this = this;

    this.swipeContainer = new PIXI.Container();
    this.swipeContainer.width = this.swipeContainerWidth;
    this.swipeContainer.height = this.swipeContainerHeight;
    this.swipeContainer.alpha = 0;
    this.graphicsContainer.addChild(this.swipeContainer);

    frameAnimationHelper.create(
      this.swipeContainer,
      data.swipeInstructionPaths,
      1,
      true,
      this.swipeContainerWidth,
      this.swipeContainerHeight);

    this.swipeText = new PIXI.Text('SWIPE UP TO SHOOT',
      {
        font: '18px orbitron',
        fill: 'white',
        align: 'center',
      }
    );

    this.swipeText.resolution = 2;
    this.swipeContainer.addChild(this.swipeText);
    this.swipeText.x = (this.swipeContainerWidth / 2) - (this.swipeText.width / 2);
    this.swipeText.y = -20;

    this.tween = window.TweenLite.to(
      this.swipeContainer,
      1,
      {
        alpha: 1,
        ease: window.Linear.easeNone,
      }
    );

    this.tween = window.TweenLite.to(
      this.swipeContainer,
      1,
      {
        delay: 3,
        alpha: 0,
        ease: window.Linear.easeNone,
        onComplete() {
          _this.graphicsContainer.removeChild(_this.swipeContainer);

          if (_this.supportsDeviceMotion) {
            _this.showTiltInstructions();
          } else {
            _this.graphicsContainer.removeChild(_this.tiltContainer);
            router.navigate('game');
          }
        },
      }
    );

    this.positionGraphics();
  },


  /**
   * Shows the tilt instructions
   * @returns {undefined} undefined
   */
  showTiltInstructions() {
    const _this = this;

    this.viewingSectionInt = 1;
    this.tiltContainer = new PIXI.Container();
    this.tiltContainer.width = this.tiltContainerWidth;
    this.tiltContainer.height = this.tiltContainerHeight;
    this.tiltContainer.alpha = 0;
    this.graphicsContainer.addChild(this.tiltContainer);

    frameAnimationHelper.create(
      this.tiltContainer,
      data.tiltInstructionPaths,
      2,
      true,
      this.tiltContainerWidth,
      this.tiltContainerHeight);

    this.tiltText = new PIXI.Text('TILT TO MOVE CURRY',
      {
        font: '18px orbitron',
        fill: 'white',
        align: 'center',
      }
    );

    this.tiltText.resolution = 2;
    this.tiltContainer.addChild(this.tiltText);
    this.tiltText.x = (this.tiltContainerWidth / 2) - (this.tiltText.width / 2);
    this.tiltText.y = -20;


    this.tween = window.TweenLite.to(
      this.tiltContainer,
      1,
      {
        alpha: 1,
        ease: window.Linear.easeNone,
      }
    );

    this.tween = window.TweenLite.to(
      this.tiltContainer,
      1,
      {
        delay: 3,
        alpha: 0,
        ease: window.Linear.easeNone,
        onComplete() {
          _this.graphicsContainer.removeChild(_this.tiltContainer);
          router.navigate('game');
        },
      }
    );

    this.positionGraphics();
  },


  /**
   * Advances the instructions
   * @returns {undefined} undefined
   */
  advanceInstructions() {
    const _this = this;

    if (this.tween) {
      this.tween.kill();
    }

    if (this.viewingSectionInt === 0) {
      this.tween = window.TweenLite.to(
        this.swipeContainer,
        1,
        {
          alpha: 0,
          ease: window.Linear.easeNone,
          onComplete() {
            _this.graphicsContainer.removeChild(_this.swipeContainer);
            if (_this.supportsDeviceMotion) {
              _this.showTiltInstructions();
            } else {
              _this.graphicsContainer.removeChild(_this.tiltContainer);
              router.navigate('game');
            }
          },
        }
      );
    }

    if (this.viewingSectionInt === 1) {
      this.tween = window.TweenLite.to(
        this.tiltContainer,
        1,
        {
          alpha: 0,
          ease: window.Linear.easeNone,
          onComplete() {
            _this.graphicsContainer.removeChild(_this.tiltContainer);
            router.navigate('game');
          },
        }
      );
    }
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    if (this.swipeContainer) {
      this.swipeContainer.x = Math.round((window.innerWidth / 2) -
        (this.swipeContainerWidth / 2));
      this.swipeContainer.y = Math.round((window.innerHeight / 2) -
        (this.swipeContainerHeight / 2)) + 10;
    }

    if (this.tiltContainer) {
      this.tiltContainer.x = Math.round((window.innerWidth / 2) -
        (this.tiltContainerWidth / 2));
      this.tiltContainer.y = Math.round((window.innerHeight / 2) -
        (this.tiltContainerHeight / 2)) + 10;
    }
  },


  /**
   * Click handler for the start button
   * @returns {undefined} undefined
   */
  onOkButtonClick() {
    this.destroy();
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    if (this.tween) {
      this.tween.kill();
      this.tween = null;
    }
    document.removeEventListener('touchend', this.advanceListener);
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.backgroundSquare);
    renderHelper.stage.removeChild(this.graphicsContainer);
  },
};

export default instructionsView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/instructions.js
 **/